import { useCallback, useEffect, useState } from 'react'

/*
 * The size of an element, kept current as the grid resizes it. Charts need it
 * in pixels — recharts draws at a given width and height — and the widgets read
 * it to decide what fits: axes, legends, how many labels.
 *
 * A callback ref, not a ref object: the chart's box only mounts once the data
 * is in, after the widget itself, and an effect run at the widget's mount
 * would find nothing to observe.
 */
const useElementSize = () => {
    const [element, setElement] = useState(null)
    const [size, setSize] = useState({ width: 0, height: 0 })
    const ref = useCallback(node => setElement(node), [])

    useEffect(() => {
        if (!element) return
        const observer = new ResizeObserver(([entry]) => {
            const { width, height } = entry.contentRect
            setSize(prev => (Math.round(prev.width) === Math.round(width) && Math.round(prev.height) === Math.round(height)) ? prev : { width, height })
        })
        observer.observe(element)
        return () => observer.disconnect()
    }, [element])

    return [ref, size]
}

export default useElementSize
